import type { CSSProperties, ReactElement, ReactNode } from "react";
import { palette, radius, typography } from "@ux/tokens";

export type BadgeTone = "neutral" | "ok" | "warn" | "danger" | "accent";

export interface BadgeProps {
    readonly tone?: BadgeTone;
    readonly children?: ReactNode;
}

export function Badge({ tone = "neutral", children }: BadgeProps): ReactElement {
    const surface = resolveSurface(tone);
    const style: CSSProperties = {
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "3px 10px",
        borderRadius: radius.pill,
        fontSize: typography.size.xs,
        fontWeight: typography.weight.bold,
        letterSpacing: "0.02em",
        ...surface,
    };
    return <span style={style}>{children}</span>;
}

function resolveSurface(tone: BadgeTone): Pick<CSSProperties, "background" | "color"> {
    switch (tone) {
        case "neutral":
            return { background: palette.surfaceRaised, color: palette.fgMuted };
        case "ok":
            return { background: palette.successBg, color: palette.success };
        case "warn":
            return { background: palette.warnBg, color: palette.warn };
        case "danger":
            return { background: palette.dangerBg, color: palette.danger };
        case "accent":
            return { background: palette.accentBg, color: palette.accentFg };
    }
}
